var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as fromStore from '../../_store';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ContactTypeEnum } from './enum/contact-type.enum';
import { take } from 'rxjs/operators';
import * as fromGlobalStore from '@ibe/store/index';
import { Router } from '@angular/router';
var PassengerDetailContactsComponent = /** @class */ (function () {
    function PassengerDetailContactsComponent(fb, store, globalStore, router) {
        this.fb = fb;
        this.store = store;
        this.globalStore = globalStore;
        this.router = router;
        this.displayValidationMessages = false;
        this.form = this.fb.group({
            email: [null, {
                    validators: [Validators.required, Validators.email],
                    updateOn: 'blur'
                }],
            phoneType: [null, Validators.required],
            phoneCountryCode: [null, Validators.required],
            phone: [null, [Validators.required, Validators.pattern('[0-9]+')]]
        });
        this.isBookingPaymentPage = false;
        this.contactTypes = ContactTypeEnum.allValues
            .map(function (ct) { return ({ text: ContactTypeEnum.description(ct), value: ct }); });
        this.phoneCountryCodes = [];
        this.sub$ = new Subscription();
        this._hasChanges = new BehaviorSubject(false);
    }
    Object.defineProperty(PassengerDetailContactsComponent.prototype, "hasChanges", {
        get: function () {
            return this._hasChanges.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailContactsComponent.prototype, "hasData", {
        get: function () {
            return !_.isEmpty(this.form.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailContactsComponent.prototype, "classViewOnlyForm", {
        get: function () {
            return Object.is('view', this.displayMode) ? 'sidebar__form--view-only' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailContactsComponent.prototype, "invalidatedClassEmail", {
        get: function () {
            return this.form.get('email').invalid && this.form.touched && this.displayValidationMessages ? 'invalidated' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailContactsComponent.prototype, "hasErrorClassPhoneType", {
        get: function () {
            return this.form.get('phoneType').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailContactsComponent.prototype, "hasErrorPhoneCountryCode", {
        get: function () {
            return this.form.get('phoneCountryCode').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PassengerDetailContactsComponent.prototype, "hasErrorPhone", {
        get: function () {
            return this.form.get('phone').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    PassengerDetailContactsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) {
            this.isBookingPaymentPage = true;
        }
        this.sub$.add(this.globalStore.select(fromGlobalStore.getSelectedCountryCodesPrefixOpts)
            .subscribe(function (data) { return _this.phoneCountryCodes = data; }));
        this.sub$.add(this.store.select(fromStore.getSelectedPassengersAtIndex).subscribe(function (data) {
            _this.form.patchValue(__assign({}, data, { phoneCountryCode: _this.mapPhoneCountryCode(data.phoneCountryCode) }), { emitEvent: false });
            _this.updateFormValidity();
            if (_this.hasData && _this.form.valid) {
                _this.displayMode = _this.isBookingPaymentPage ? 'edit' : 'view';
            }
            else {
                _this.displayMode = 'edit';
            }
        }));
        this.sub$.add(this.form.valueChanges.subscribe(function () {
            _this._hasChanges.next(true);
            _this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateContact': true }));
        }));
        // this.emailChangedUpdateValidations();
        // this.contactInfoChangedUpdateValidations();
        // dispatch by default since contact section is always required
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateContact': true }));
    };
    PassengerDetailContactsComponent.prototype.mapPhoneCountryCode = function (countryCode) {
        if (!_.isNil(countryCode)) {
            return Object.is('+', countryCode.charAt(0)) ? countryCode : '+' + countryCode;
        }
        return null;
    };
    PassengerDetailContactsComponent.prototype.emailChangedUpdateValidations = function () {
        var emailControl = this.form.get('email');
        var phoneTypeControl = this.form.get('phoneType');
        var phoneCountryCodeControl = this.form.get('phoneCountryCode');
        var phoneControl = this.form.get('phone');
        emailControl.valueChanges.subscribe(function (value) {
            if (!_.isEmpty(value) && emailControl.valid) {
                phoneTypeControl.clearValidators();
                phoneCountryCodeControl.clearValidators();
                phoneControl.clearValidators();
            }
            else {
                phoneTypeControl.setValidators(Validators.required);
                phoneCountryCodeControl.setValidators(Validators.required);
                phoneControl.setValidators(Validators.required);
            }
            phoneTypeControl.updateValueAndValidity({ emitEvent: false });
            phoneCountryCodeControl.updateValueAndValidity({ emitEvent: false });
            phoneControl.updateValueAndValidity({ emitEvent: false });
        });
    };
    PassengerDetailContactsComponent.prototype.contactInfoChangedUpdateValidations = function () {
        var _this = this;
        var emailControl = this.form.get('email');
        this.sub$.add(this.form.get('phoneCountryCode').valueChanges.subscribe(function (value) {
            var _a = _this.form.value, phoneType = _a.phoneType, phone = _a.phone;
            _this.verifyEmailValidity(emailControl, value, phoneType, phone);
        }));
        this.sub$.add(this.form.get('phoneType').valueChanges.subscribe(function (value) {
            var _a = _this.form.value, phoneCountryCode = _a.phoneCountryCode, phone = _a.phone;
            _this.verifyEmailValidity(emailControl, phoneCountryCode, value, phone);
        }));
        this.sub$.add(this.form.get('phone').valueChanges.subscribe(function (value) {
            var _a = _this.form.value, phoneCountryCode = _a.phoneCountryCode, phoneType = _a.phoneType;
            _this.verifyEmailValidity(emailControl, phoneCountryCode, phoneType, value);
        }));
    };
    PassengerDetailContactsComponent.prototype.verifyEmailValidity = function (emailControl, phoneCountryCode, phoneType, phone) {
        if (!_.isEmpty(phoneCountryCode) && !_.isEmpty(phoneType) && !_.isEmpty(phone)) {
            emailControl.setValidators([
                Validators.email
            ]);
        }
        else {
            emailControl.setValidators([
                Validators.required,
                Validators.email
            ]);
        }
        emailControl.updateValueAndValidity({ emitEvent: false });
    };
    PassengerDetailContactsComponent.prototype.updateFormValidity = function () {
        var _a = this.form.value, email = _a.email, phoneCountryCode = _a.phoneCountryCode, phone = _a.phone, phoneType = _a.phoneType;
        var isEmailValid = !_.isEmpty(email);
        var isContactValid = !_.isEmpty(phoneCountryCode) && !_.isEmpty(phoneType) && !_.isEmpty(phone);
        if (isEmailValid) {
            var phoneTypeControl = this.form.get('phoneType');
            var phoneCountryCodeControl = this.form.get('phoneCountryCode');
            var phoneControl = this.form.get('phone');
            phoneTypeControl.clearValidators();
            phoneCountryCodeControl.clearValidators();
            phoneControl.clearValidators();
            phoneTypeControl.updateValueAndValidity({ emitEvent: false });
            phoneCountryCodeControl.updateValueAndValidity({ emitEvent: false });
            phoneControl.updateValueAndValidity({ emitEvent: false });
        }
        if (isContactValid) {
            var emailControl = this.form.get('email');
            emailControl.clearValidators();
            emailControl.updateValueAndValidity({ emitEvent: false });
        }
    };
    PassengerDetailContactsComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    PassengerDetailContactsComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    PassengerDetailContactsComponent.prototype.formContactsErrors = function (control) {
        var errors = [];
        if (Object.is('email', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.paxContactEmailRequired');
            }
            if (this.form.controls[control].hasError('email')) {
                errors.push('bookingDetails.error.paxContactEmailInvalid');
            }
        }
        if (Object.is('phoneType', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.paxContactPhoneNumTypeRequired');
            }
        }
        if (Object.is('phoneCountryCode', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.paxContactCountryRequired');
            }
        }
        if (Object.is('phone', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.paxContactPhoneNumRequired');
            }
            /*
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.paxContactPhoneNumPattern');
            }
            */
        }
        return errors.join('; ');
    };
    PassengerDetailContactsComponent.prototype.clearForm = function () {
        this.form.reset();
    };
    PassengerDetailContactsComponent.prototype.cancelEditForm = function () {
        var _this = this;
        this.store.select(fromStore.getSelectedPassengersAtIndex)
            .pipe(take(1)).subscribe(function (data) {
            _this.form.reset(__assign({}, data, { phoneCountryCode: _this.mapPhoneCountryCode(data.phoneCountryCode) }), { emitEvent: false });
            _this._hasChanges.next(false);
        });
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateContact': false }));
        this.displayMode = 'view';
    };
    PassengerDetailContactsComponent.prototype.openEditForm = function () {
        this.displayMode = 'edit';
    };
    return PassengerDetailContactsComponent;
}());
export { PassengerDetailContactsComponent };
